import apiClient from "../../utils/interceptor";
import { ApiResponse, MachineData, CreateMachineParams, UpdateMachineParams, CreateMachineResponse } from "./interface";
import { API_URLS } from "../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get all machines
export const getAllMachines = async (): Promise<ApiResponse<MachineData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<MachineData[]>>(
            API_URLS.MACHINE.GET_MACHINES,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching machines:", error);
        throw error;
    }
};

// Function to create a machine
export const createMachine = async (
    machineParams: CreateMachineParams
): Promise<ApiResponse<CreateMachineResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateMachineResponse>>(
            API_URLS.MACHINE.CREATE_MACHINE,
            machineParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating machine:", error);
        throw error;
    }
};

// Function to update a machine
export const updateMachine = async (
    machineData: UpdateMachineParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.MACHINE.UPDATE_MACHINE,
            machineData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating machine:", error);
        throw error;
    }
};

// Function to delete (disable) a machine
export const deleteMachine = async (
    machineId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            API_URLS.MACHINE.DELETE_MACHINE,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { machine_id: machineId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting machine:", error);
        throw error;
    }
};
